import React from 'react';
import {Dinheiro} from '@contentsys/contentsys-react-components';
import {Row, Col} from 'antd';

import styles from './styles/totalBar.scss';


const TotalBar = props => {

    const {children, visible} = props;

    if(!visible)
        return <></>;

    console.log(Array.isArray(children) );
    console.log(children );
    if(Array.isArray(children) && children.length > 1){

        return (
            <Row style={{position: "sticky", bottom : "0"}} className="totalBarWrapper">
                <Col span={12}>
                    {children[0]}
                </Col>
                <Col span={12} 
                     style={{
                        textAlign: "right",
                        'paddingRight': '24px',
                        'paddingTop': '10px',
                        'lineHeight': '49px'
                     }}
                >

                    {children[1]}
                </Col>
            </Row>
        );
    } else if (typeof children == "object"){
        return (
            <Row style={{position: "sticky", bottom : "0"}} className="totalBarWrapper">
                <Col span={24}>
                    {children}
                </Col>
                
            </Row>
        );
    }


};

export {TotalBar};